<template>
  <BTable
    v-bind="$attrs"
    :selected="value"
    :headers="filteredHeaders"
    :actions="actions"
    :list="list"
    v-on="$listeners || {}"
  >
    <!--  -->

    <template #item.username="{ header, item }">
      <router-link
        :to="header.getRoute(item)"
        v-text="item.username"
      />
    </template>

    <template #item.is_superuser="{ item }">
      <v-icon
        v-if="item.is_superuser"
        color="success"
        size="16px"
        class="mr-2"
        v-text="'mdi-checkbox-marked-outline'"
      />

      <v-icon
        v-else
        color="gray"
        size="16px"
        class="mr-2"
        v-text="'mdi-close-circle-outline'"
      />
    </template>

    <!--  -->
  </BTable>
</template>

<script>
import {
  TABLE_HEADERS,
  TABLE_ACTIONS,
} from '@/views/Users/table-headers'

import BTable from '@/components/common/BTable.vue'

export default {
  name: 'BTableUsers',
  components: {
    BTable,
  },
  inheritAttrs: false,
  props: {
    value: Array,
    headers: {
      type: Array,
      default: () => TABLE_HEADERS,
    },
    actions: {
      type: Array,
      default: () => TABLE_ACTIONS,
    },
    list: {
      type: Array,
    },
  },
  computed: {
    filteredHeaders() {
      const { list, headers } = this
      if (!list?.length) return headers
      const props = Object.keys(list[0])
      return headers.filter((_) => !_.value || props.includes(_.value))
    },
  },
}
</script>
